/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StocktakeReports
 */
angular.module('mercury.modules.stock.stockonhandreport')
.factory('StockOnHand', ["$http", "$q", "settings", function($http, $q, settings) {

  /**
   * Run the stock on hand report for an item Category
   *
   * @memberof StockonhandReports
   * @param  {String} itemCategoryId Id item category
   */
  function StockOnHandReport(templateType, templateId) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: settings.apiHost + '/r/StockOnHand',
      params: {templateType: templateType, templateId: templateId}
    })
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * Use OData query to get the Item Categories from our Item Groups Endpoint
   *
   * @memberof StockonhandReports
   */
  function ItemCategories() {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: settings.apiHost + '/r/StockItemGroups?$apply=groupby((SuperGroupId,SuperGroupName))&$orderby=SuperGroupName'
    })
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  return {
    StockOnHandReport: StockOnHandReport,
    ItemCategories: ItemCategories
  };
}]);
